import awesomeGreen from './awesome-green.png';
import blackOrange from './black-orange.png';
import blueHue from './blue-hue.png';
import blueOrange from './blue-orange.png';
import blueRed from './blue-red.png';
import grayScale from './grayscale.png';
import heatMap from './heat-map.png';
import jet from './jet.png';
import pastelShades from './pastel-shades.png';
import {ColorMapKey} from "../../../redux/settings-slice";

interface ColorMap {
  id: ColorMapKey;
  name: string;
  image: string;
}

export const colorMaps: ColorMap[] = [
  {
    id: 'heat-map',
    name: 'Heat Map',
    image: heatMap
  },
  {
    id: 'awesome-green',
    name: 'Green',
    image: awesomeGreen
  },
  {
    id: 'pastel-shades',
    name: 'Pastel',
    image: pastelShades
  },
  {
    id: 'blue-orange',
    name: 'Blue/Orange',
    image: blueOrange
  },
  {
    id: 'black-orange',
    name: 'Black/Orange',
    image: blackOrange
  },
  {
    id: 'blue-hue',
    name: 'Blue',
    image: blueHue
  },
  {
    id: 'blue-red',
    name: 'Blue/Red',
    image: blueRed
  },
  {
    id: 'jet',
    name: 'Rainbow',
    image: jet
  },
  {
    id: 'grayscale',
    name: 'Grayscale',
    image: grayScale
  },
];